import { useCandidateHistory } from '../../hooks/useCandidateHistory';
import { formatPercent, formatPrice, formatRelativeTime } from '../../lib/format';
import { Badge } from '../ui/Badge';
import { Panel } from '../ui/Panel';

export function CandidateHistoryPanel({ symbol }: { symbol: string }): React.JSX.Element {
  const history = useCandidateHistory(symbol);
  return (
    <Panel
      title="Local candidate record"
      description="Frozen candidate episodes preserved on this device. A later state never rewrites the original discovery price or thesis."
    >
      {history.loading ? (
        <div className="loading-block loading-block-compact" />
      ) : history.error ? (
        <div className="notice">{history.error}</div>
      ) : history.episodes.length === 0 ? (
        <div className="table-empty">No candidate episode for this coin has been archived on this device yet.</div>
      ) : (
        <div className="candidate-history-list">
          {history.episodes.map((episode) => (
            <article className="candidate-history-item" key={episode.id}>
              <div className="candidate-history-head">
                <div>
                  <strong>{episode.family.replaceAll('-', ' ')}</strong>
                  <span>{episode.horizon} · found {formatRelativeTime(episode.foundAt)}</span>
                </div>
                <Badge tone={episode.direction === 'long' ? 'positive' : episode.direction === 'short' ? 'negative' : 'neutral'}>
                  {episode.direction}
                </Badge>
              </div>
              <div className="candidate-history-metrics">
                <span>Found ${formatPrice(episode.foundPrice)}</span>
                <span>Found 24h {formatPercent(episode.foundChange24h)}</span>
                <span>Since found {formatPercent(episode.changeSinceFound)}</span>
                <span>Best {formatPercent(episode.bestMove)}</span>
                <span>Worst {formatPercent(episode.worstMove)}</span>
                <span>{episode.state}</span>
                <span>Found quality {episode.discovery?.candidateScore ?? 'Unavailable'} · current {episode.candidateScore}</span>
                <span>Deep {episode.validationStatus} · {(episode.validationCoverage * 100).toFixed(0)}%</span>
              </div>
              <p>{episode.statusNote}</p>
            </article>
          ))}
        </div>
      )}
    </Panel>
  );
}
